import { render, staticRenderFns } from "./ShareActionSheet.vue?vue&type=template&id=09822436&"
import script from "./ShareActionSheet.vue?vue&type=script&lang=js&"
export * from "./ShareActionSheet.vue?vue&type=script&lang=js&"
import style0 from "./ShareActionSheet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports